"use client";
import { useScrollReveal } from "@/hooks/common/useScrollReveal";
import GcsImage from "@/components/common/GcsImage";
import { chubbLogo, foremostLogo } from "@/lib/gcsImagePaths";
import { libertyMutualLogo, nationalGeneralLogo } from "@/lib/gcsImagePaths";
import { nationwideLogo, orionLogo } from "@/lib/gcsImagePaths";
import { progressiveLogo, pureLogo } from "@/lib/gcsImagePaths";
import { travelersLogo, universalLogo } from "@/lib/gcsImagePaths";

export default function Partners() {
  const { ref, isVisible } = useScrollReveal();

  return (
    <section
      ref={ref}
      className={`py-16 bg-muted/30 transition-all duration-700 ${
        isVisible ? "animate-fade-in" : "opacity-0"
      }`}
    >
      <div className="container mx-auto px-4">
        <h2 className="text-2xl md:text-3xl font-bold text-foreground mb-4 text-center">
          We Partner With The Best To Protect You
        </h2>
        <p className="text-base text-muted-foreground/60 text-center mb-8 tracking-wider">
          SELECT CARRIERS
        </p>
        <div className="flex flex-wrap justify-center items-center gap-8 md:gap-12 max-w-6xl mx-auto">
          <GcsImage
            path={progressiveLogo}
            alt="Progressive"
            className="h-6 w-auto object-contain transition-all"
          />
          <GcsImage
            path={nationwideLogo}
            alt="Nationwide"
            className="h-11 w-auto object-contain transition-all"
          />
          <GcsImage
            path={libertyMutualLogo}
            alt="Liberty Mutual"
            className="h-10 w-auto object-contain transition-all"
          />
          <GcsImage
            path={travelersLogo}
            alt="Travelers"
            className="h-10 w-auto object-contain transition-all"
          />
          <GcsImage
            path={pureLogo}
            alt="Pure Insurance"
            className="h-10 w-auto object-contain transition-all"
          />
          <GcsImage
            path={chubbLogo}
            alt="Chubb"
            className="h-4 w-auto object-contain transition-all"
          />
          <GcsImage
            path={foremostLogo}
            alt="Foremost"
            className="h-10 w-auto object-contain transition-all"
          />
          <GcsImage
            path={nationalGeneralLogo}
            alt="National General"
            className="h-10 w-auto object-contain transition-all"
          />
          <GcsImage
            path={orionLogo}
            alt="Orion"
            className="h-10 w-auto object-contain transition-all"
          />
          <GcsImage
            path={universalLogo}
            alt="Universal Insurance"
            className="h-10 w-auto object-contain transition-all"
          />
        </div>
      </div>
    </section>
  );
}
